import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import blogPosts from '../BlogPosts';
import '../App.css';

const BlogPost = () => {
    const { slug } = useParams();
    const blogPost = blogPosts.find(post => post.slug === slug);
  
    if (!blogPost) {
      return <div className="blog-post"><h2>Blog post not found!</h2></div>;
    }
  
    const renderContent = (content) => {
      return content.map((item, index) => {
        if (typeof item === 'string') {
          return <p key={index}>{item}</p>;
        }
  
        switch (item.type) {
          case 'header':
            return <h2 key={index}>{item.text}</h2>;
          case 'image':
            return (
              <div key={index}>
                <img src={item.src} alt={item.caption} />
                {item.caption && <p className='caption'>{item.caption}</p>}
              </div>
            );
          case 'link':
            const { beforeText, linkText, afterText } = item;
            return (
              <p key={index}>
                {beforeText}
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  {linkText}
                </a>
                {afterText}
              </p>
            );
          case 'video':
            const embedUrl = `https://www.youtube.com/embed/${item.embedKey}`;
  
            return (
              <div key={index}>
                <iframe
                  src={embedUrl}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
                <p className='caption'>{item.caption}</p>
              </div>
            );
          default:
            return null;
        }
      });
    };
  
    return (
      <div className="blog-post-container">
        <div className="blog-post">
          <h1>{blogPost.title}</h1>
          <p className='blog-info'>by Johnathan Browning, {new Date(blogPost.date).toLocaleDateString('en-US', { timeZone: 'UTC' })}</p>
          <div className="blog-content">
            {renderContent(blogPost.content)}
          </div>
        </div>
  
        <Sidebar 
          blogPosts={blogPosts}
        />
      </div>
    );
  };
  
  export default BlogPost;